import React from "react";
import Registration from "../templates/Registration";
import NotFound from "../templates/NotFound";

const RegistrationPreview = ({ config, brand }) => {
  if (!config) return <NotFound />;

  return <Registration config={config} isPreviewForm={true} brand={brand} />;
};

export default RegistrationPreview;
